module.exports = __webpack_public_path__ + "media/images/prop-img-320-919ae011b4d79e1b6653c8965c81f40e.svg";